module.exports = __webpack_public_path__ + "static/fowf-chris-color-fad6b0abfb09f5ec7de0520941a95638.jpg";